import React, { useState, useEffect } from "react";
import { useForm, ValidationError } from "@formspree/react";
import toast, { Toaster } from "react-hot-toast";
import styles from "../styles/contact-form.module.css";

function EnvelopeForm() {
  const [flipCard, setFlipCard] = useState(false);
  const [slideOut, setSlideOut] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [state, handleSubmit] = useForm("xjkoqlrz");

  useEffect(() => {
    if (state.succeeded) {
      toast.success("Message sent successfully!");
      // Start the envelope animation when message succeeded
      setFlipCard(true);
      setSlideOut(true);
    }
  }, [state.succeeded]);

  useEffect(() => {
    if (Array.isArray(state.errors) && state.errors.length > 0) {
      state.errors.forEach((error) => {
        toast.error(error.message);
      });
    }
  }, [state.errors]);

  const handleAnimationEnd = (e) => {
    if (e.animationName === "slideOut") setHidden(true);
  };

  if (hidden) return null;

  return (
    <div className={styles.contactWrapper}>
      <div
        className={`${styles.envelope} ${flipCard ? styles.active : ""} ${
          slideOut ? styles.slideOut : ""
        }`}
        onAnimationEnd={handleAnimationEnd}
      >
        <div className={`${styles.back} ${styles.paper}`}></div>
        <div className={styles.content}>
          <div className={styles.formWrapper}>
            <form className={styles.contactForm} onSubmit={handleSubmit}>
              <div className={styles.topWrapper}>
                <div className={styles.input}>
                  <label>Name: </label>
                  <input type="text" name="name" required />
                </div>
                <div className={styles.input}>
                  <label>Email: </label>
                  <input type="email" name="email" required />
                  <ValidationError
                    prefix="Email"
                    field="email"
                    errors={state.errors}
                  />
                </div>
                <div className={styles.input}>
                  <label>Subject: </label>
                  <input type="text" name="subject" />
                </div>
              </div>
              <div className={styles.bottomWrapper}>
                <div className={styles.input}>
                  <label>Message: </label>
                  <textarea rows="5" name="message" required />
                  <ValidationError
                    prefix="Message"
                    field="message"
                    errors={state.errors}
                  />
                </div>
                <div className={styles.submit}>
                  <button
                    type="submit"
                    className={styles.submitCard}
                    disabled={state.submitting || slideOut}
                  >
                    Send
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className={`${styles.front} ${styles.paper}`}></div>
      </div>
    </div>
  );
}

function SimpleContactForm() {
  const [state, handleSubmit] = useForm("xjkoqlrz");

  useEffect(() => {
    if (state.succeeded) {
      toast.success("Message sent successfully!");
    }
  }, [state.succeeded]);

  useEffect(() => {
    if (Array.isArray(state.errors) && state.errors.length > 0) {
      state.errors.forEach((error) => {
        toast.error(error.message);
      });
    }
  }, [state.errors]);


  return (
    <div className={styles.contactWrapper}>
      <h2>Contact Us</h2>
      <form className={styles.contactForm} onSubmit={handleSubmit}>
        <div className={styles.input}>
          <label>Name</label>
          <input type="text" name="name" required />
        </div>
        <div className={styles.input}>
          <label>Email</label>
          <input type="email" name="email" required />
          <ValidationError prefix="Email" field="email" errors={state.errors} />
        </div>
        <div className={styles.input}>
          <label>Subject</label>
          <input type="text" name="subject" />
        </div>
        <div className={styles.input}>
          <label>Message</label>
          <textarea rows="5" name="message" required />
          <ValidationError prefix="Message" field="message" errors={state.errors} />
        </div>
        <button type="submit" className={styles.submitCard} disabled={state.submitting}>
          Send
        </button>
      </form>
    </div>
  );
}

export default function Contact() {
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsLargeScreen(window.innerWidth >= 1024);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Toaster position={isLargeScreen ? "bottom-center" : "top-center"} />
      {isLargeScreen ? <EnvelopeForm /> : <SimpleContactForm />}
    </>
  );
}
